const apis = {
    get_vouchers_auth: '/comprobantes/autorizados/busqueda/',
    post_save_credit_note: '/generacion/comprobantes/ebox/nota/credito',
    post_generate_ride: '/core/generacion/comprobantes/ebox/ride/nota/credito',
    post_find_invoice: "/generacion/comprobantes/ebox/cargar/factura",
    get_secuencial_user: '/asignacion/secuencial/usuario/secuencial'
};

export default apis;